'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["options"];
import { DropdownTextItem } from "../../primitive-dropdown/dropdown-text-item";
import { AsyncGenericDropdown } from "./async-generic-dropdown";
import { jsx as _jsx } from "react/jsx-runtime";
export function AsyncTextsDropdown(_ref) {
  var options = _ref.options,
    props = _objectWithoutProperties(_ref, _excluded);
  var textOptions = options.map(function (option) {
    return {
      value: option.value,
      label: option.label,
      description: option.description,
      element: function element(elementProps) {
        return /*#__PURE__*/_jsx(DropdownTextItem, _objectSpread({
          text: option.label,
          description: option.description
        }, elementProps));
      }
    };
  });
  return /*#__PURE__*/_jsx(AsyncGenericDropdown, _objectSpread(_objectSpread({}, props), {}, {
    options: textOptions
  }));
}